import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { AdvanceToUnlock, EventDebits } from '../../types/event-debits'

export interface useBalanceDistributionProps {
  balance: AxiosResponse<FetchResponse> | undefined
  isLoading: boolean
  isError: AxiosError
}

export interface AdvanceBalanceDistributionProps {
  advanceOrigin: string
  totalOrigin: number
  advanceLimit: number
  totalAdvanced: string
  lastBalanceAdvancedDate: string | null
  advanceToUnlock?: AdvanceToUnlock
}

interface AdvanceBalanceProps {
  balance: AdvanceBalanceDistributionProps[]
  eventDebits?: EventDebits
}

interface FetchResponse {
  success: boolean
  data: AdvanceBalanceProps
}

export const useAdvanceBalanceDistribution = (
  id: number,
  forceBalance: boolean | undefined = false
): useBalanceDistributionProps => {
  let url: string = `producer/analytics/balanceAdvanceDistribution?eventId=${id}`
  const option = '&forceReturnBalance=true'
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  if (forceBalance !== undefined && forceBalance) {
    url = url + option
  }

  const { data, error, isLoading } = useSWR(url, fetchData, {
    refreshInterval: 60000 * 3,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

  return {
    balance: data,
    isLoading,
    isError: error,
  }
}
